import { Card, DatePicker } from "antd";
import moment from "moment";
import React, { createContext, useContext, useEffect, useState } from "react";
import { SettingContext } from "../../routes";
import CustomHeader from "../common/Header";
import { Chart1 } from "./Chart1";
import { Chart2 } from "./Chart2";
import { Chart3 } from "./Chart3";
import { Chart4 } from "./Chart4";
import { Chart5 } from "./Chart5";

const { RangePicker } = DatePicker;
const MaintenanceAnalyticsContext = createContext();

function MaintenanceAnalytics() {
    const { setSelectedHotelType } = useContext(SettingContext);

    const [selectedDates, setSelectedDates] = useState([
        moment()
            .subtract(7, "days")
            .startOf("day")
            .format("YYYY/MM/DD HH:MM:SS"),
        moment()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY/MM/DD HH:MM:SS"),
    ]);
    useEffect(() => {
        setSelectedHotelType("operation");
        return () => {
            setSelectedHotelType("all");
        };
    }, []);

    function handleDateChange(e) {
        let start_date =
            e !== null ? moment(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? moment(e[1]).startOf("day") : selectedDates[1];

        // set the default value if null
        setSelectedDates([start_date, end_date]);
    }

    function disableFutureDates(current) {
        return current && current > moment().startOf("day");
    }

    return (
        <MaintenanceAnalyticsContext.Provider
            value={{ selectedDates, setSelectedDates }}
        >
            <CustomHeader
                extraAfter={
                    <RangePicker
                        allowClear={false}
                        disabledDate={disableFutureDates}
                        defaultValue={[
                            moment(selectedDates[0]),
                            moment(selectedDates[1]),
                        ]}
                        value={[
                            moment(selectedDates[0]),
                            moment(selectedDates[1]),
                        ]}
                        className="dashboard-date-search"
                        onChange={handleDateChange}
                        format="MM/DD/YYYY"
                        ranges={{
                            // Today: [moment(), moment()],
                            Yesterday: [
                                moment().subtract(1, "day"),
                                moment().subtract(1, "day"),
                            ],
                            "Last 7 Days": [
                                moment().subtract(8, "day"),
                                moment().subtract(1, "day"),
                            ],
                            "Last 30 Days": [
                                moment().subtract(30, "day"),
                                moment().subtract(1, "day"),
                            ],
                            "Current Month": [
                                moment().startOf("month"),
                                moment().subtract(1, "day"),
                            ],
                            "Last Month": [
                                moment().subtract(1, "month").startOf("month"),
                                moment().subtract(1, "month").endOf("month"),
                            ],
                            "Last 3 Month": [
                                moment().subtract(3, "month"),
                                moment().subtract(1, "day"),
                            ],
                        }}
                    />
                }
            />
            <div style={{ display: "flex", flexDirection: "column" }}>
                <Card className="margin-5" hoverable>
                    <Chart1 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart2 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart3 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart4 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart5 />
                </Card>
            </div>
        </MaintenanceAnalyticsContext.Provider>
    );
}

export { MaintenanceAnalytics, MaintenanceAnalyticsContext };
